module.exports = __webpack_public_path__ + "static/ixopay-1238d18fd61165e1da8cae78512ac57b.png";